import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  doc,
  setDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";

const AdminReferralCodes = () => {
  const [newCode, setNewCode] = useState("");
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copiedCode, setCopiedCode] = useState("");

  // Fetch all referral codes
  useEffect(() => {
    const fetchCodes = async () => {
      setLoading(true);
      const snapshot = await getDocs(collection(db, "referral_codes"));
      setCodes(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    };
    fetchCodes();
  }, []);

  // Create a new Level 1 code
  const handleCreate = async (e) => {
    e.preventDefault();
    if (!newCode) return;
    const code = newCode.trim().toUpperCase();
    await setDoc(doc(db, "referral_codes", code), {
      enabled: true,
      level: 1,
    });
    setCodes([{ id: code, enabled: true, level: 1 }, ...codes]);
    setNewCode("");
    alert("Level 1 referral code created!");
  };

  // Enable/Disable code
  const toggleEnable = async (id, enabled) => {
    await updateDoc(doc(db, "referral_codes", id), { enabled: !enabled });
    setCodes(codes.map((c) => (c.id === id ? { ...c, enabled: !enabled } : c)));
  };

  const handleCopyLink = (code) => {
    const link = `https://cource-referral-web.vercel.app/register?ref=${code}`;
    navigator.clipboard.writeText(link);
    setCopiedCode(code);
    setTimeout(() => setCopiedCode(""), 1500);
  };

  return (
    // <div className="max-w-xl mx-auto p-6">
    //   <h2 className="text-2xl font-bold mb-4 text-blue-600">
    //     Admin: Level 1 Referral Codes
    //   </h2>
    //   <form className="mb-8 flex gap-2" onSubmit={handleCreate}>
    //     <input
    //       type="text"
    //       className="flex-1 px-3 py-2 border rounded"
    //       placeholder="Enter new Level 1 code (e.g. LEVEL1XYZ)"
    //       value={newCode}
    //       onChange={(e) => setNewCode(e.target.value)}
    //       required
    //     />
    //     <button
    //       type="submit"
    //       className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
    //     >
    //       Create
    //     </button>
    //   </form>
    //   <div>
    //     <h3 className="font-bold mb-2">All Level 1 Codes</h3>
    //     {loading ? (
    //       <div>Loading...</div>
    //     ) : (
    //       <table className="w-full text-sm bg-gray-100 rounded-xl overflow-hidden">
    //         <thead>
    //           <tr className="font-semibold">
    //             <th className="px-2 py-1 text-left">Code</th>
    //             <th className="px-2 py-1">Enabled</th>
    //             <th className="px-2 py-1">Action</th>
    //             <th className="px-2 py-1">Copy Link</th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {codes.map((code) => (
    //             <tr key={code.id}>
    //               <td className="px-2 py-1 font-mono">{code.id}</td>
    //               <td className="px-2 py-1 text-center">
    //                 {code.enabled ? "✅" : "⛔️"}
    //               </td>
    //               <td className="px-2 py-1 text-center">
    //                 <button
    //                   className="px-2 py-1 bg-gray-300 rounded hover:bg-gray-400"
    //                   onClick={() => toggleEnable(code.id, code.enabled)}
    //                 >
    //                   {code.enabled ? "Disable" : "Enable"}
    //                 </button>
    //               </td>
    //               <td className="px-2 py-1 text-center">
    //                 <button
    //                   className="px-2 py-1 bg-green-500 text-white rounded hover:bg-green-600 mr-2"
    //                   onClick={() => handleCopyLink(code.id)}
    //                   type="button"
    //                 >
    //                   Copy Link
    //                 </button>
    //                 {copiedCode === code.id && (
    //                   <span className="text-green-600 ml-1">Copied!</span>
    //                 )}
    //               </td>
    //             </tr>
    //           ))}
    //           {codes.length === 0 && (
    //             <tr>
    //               <td
    //                 colSpan={3}
    //                 className="px-2 py-2 text-center text-gray-500"
    //               >
    //                 No codes yet.
    //               </td>
    //             </tr>
    //           )}
    //         </tbody>
    //       </table>
    //     )}
    //   </div>
    // </div>
    <div className="max-w-2xl mx-auto px-4 py-10">
      <div className="bg-white/70 backdrop-blur rounded-2xl shadow-2xl border border-blue-100 p-8">
        <h2 className="text-3xl font-extrabold mb-6 text-blue-700 flex items-center gap-2">
          <svg
            className="w-8 h-8 text-blue-400"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path d="M12 11c1.1 0 2-.9 2-2V7a2 2 0 10-4 0v2c0 1.1.9 2 2 2zM6 12v2c0 3.3 2.7 6 6 6s6-2.7 6-6v-2"></path>
          </svg>
          Admin: Level 1 Referral Codes
        </h2>
        <form
          className="flex flex-col sm:flex-row gap-3 mb-8"
          onSubmit={handleCreate}
        >
          <input
            type="text"
            className="flex-1 px-4 py-3 border border-blue-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
            placeholder="Enter new Level 1 code (e.g. LEVEL1XYZ)"
            value={newCode}
            onChange={(e) => setNewCode(e.target.value)}
            required
          />
          <button
            type="submit"
            className="px-6 py-3 bg-blue-600 text-white rounded-xl font-bold shadow hover:bg-blue-700 active:scale-95 transition"
          >
            Create
          </button>
        </form>
        <div>
          <h3 className="font-bold mb-3 text-lg text-blue-600">
            All Level 1 Codes
          </h3>
          <div className="rounded-2xl overflow-hidden border border-blue-100 shadow">
            {loading ? (
              <div className="p-8 text-center text-blue-400 animate-pulse">
                Loading...
              </div>
            ) : (
              <table className="w-full text-sm bg-white/70">
                <thead>
                  <tr className="font-semibold bg-blue-50">
                    <th className="px-3 py-2 text-left">Code</th>
                    <th className="px-3 py-2">Enabled</th>
                    <th className="px-3 py-2">Action</th>
                    <th className="px-3 py-2">Copy Link</th>
                  </tr>
                </thead>
                <tbody>
                  {codes.map((code) => (
                    <tr key={code.id} className="hover:bg-blue-50 transition">
                      <td className="px-3 py-2 font-mono text-blue-900">
                        {code.id}
                      </td>
                      <td className="px-3 py-2 text-center">
                        {code.enabled ? (
                          <span className="inline-flex items-center gap-1 text-green-600 font-bold">
                            <svg
                              className="w-5 h-5"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            Enabled
                          </span>
                        ) : (
                          <span className="text-gray-400">Disabled</span>
                        )}
                      </td>
                      <td className="px-3 py-2 text-center">
                        <button
                          className={`px-3 py-1 rounded-xl font-semibold transition shadow
                        ${
                          code.enabled
                            ? "bg-gray-200 text-gray-700 hover:bg-gray-300"
                            : "bg-green-100 text-green-800 hover:bg-green-200"
                        }`}
                          onClick={() => toggleEnable(code.id, code.enabled)}
                        >
                          {code.enabled ? "Disable" : "Enable"}
                        </button>
                      </td>
                      <td className="px-3 py-2 text-center">
                        <button
                          className="px-3 py-1 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition font-semibold flex items-center gap-2"
                          onClick={() => handleCopyLink(code.id)}
                          type="button"
                        >
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M8 16h12a2 2 0 002-2V6a2 2 0 00-2-2H8a2 2 0 00-2 2v2"
                            />
                            <rect width="16" height="12" x="4" y="8" rx="2" />
                          </svg>
                          Copy Link
                        </button>
                        {copiedCode === code.id && (
                          <span className="text-green-600 ml-2 font-bold animate-fade-in">
                            Copied!
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                  {codes.length === 0 && (
                    <tr>
                      <td
                        colSpan={4}
                        className="px-3 py-6 text-center text-gray-400"
                      >
                        No codes yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminReferralCodes;
